export enum ProxyDirection {
    PUBLISH = 'publish',
    SUBSCRIBE = 'subscribe'
}
